import React from 'react'
import '../../css/calendarRatesLoader.css'
const CalenderLoader=()=>{
    return(<div className="roomPriceSection"></div>
    )
}

//Export hoterListLoader
export default CalenderLoader